<template>
  <div class="w-full">
    <section class="w-full mx-2 lg:w-3/4 lg:mx-auto mt-5 shadow rounded-lg overflow-hidden">
      <table class="leading-normal w-full">
        <thead>
          <tr>
            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs
              font-semibold text-gray-600 uppercase tracking-wider w-1/4">
                Teacher
            </th>
            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs
              font-semibold text-gray-600 uppercase tracking-wider w-1/4">
                Title
            </th>
            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs
              font-semibold text-gray-600 uppercase tracking-wider w-1/4">
                Date
            </th>
            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs
              font-semibold text-gray-600 uppercase tracking-wider w-1/6">
                Is Next
            </th>
            <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs
              font-semibold text-gray-600 uppercase tracking-wider w-1/6">
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="masterclass in masterclasses"
            :key="masterclass.id"
            is="MasterclassRow"
            :masterclass="masterclass">
          </tr>
        </tbody>
      </table>
    </section>

  </div>
</template>

<script>

import axios from 'axios';
import MasterclassRow from '@/components/admin/MasterclassRow.vue';

export default {
  components: {
    MasterclassRow,
  },

  data() {
    return {
      masterclasses: [],
    };
  },

  created() {
    axios.get('/api/masterclasses-all')
      .then(({ data }) => {
        this.masterclasses = data;
      });
  },

};
</script>

<style scoped>

</style>
